import { triggerConstants } from 'dibs-tracking';
import {
    trendingNowBestsellingDesigns,
    trendingNowExcellentValues,
    trendingNowMostSavedItems,
} from '../hpMessages.tsx';

import { type HpCarouselTab } from '../HpSharedCarouselTabs/HpSharedCarouselTabs.tsx';

export const MOST_SAVED_ITEMS = 'most-saved-items';
export const EXCELLENT_VALUES = 'excellent-values';
export const BESTSELLING_DESIGNS = 'bestselling-designs';

export const tabNames = [MOST_SAVED_ITEMS, EXCELLENT_VALUES, BESTSELLING_DESIGNS] as const;

export type TabName = (typeof tabNames)[number];

export const tabMap: Record<TabName, HpCarouselTab> = {
    [MOST_SAVED_ITEMS]: {
        value: MOST_SAVED_ITEMS,
        label: 'Most-Saved Items',
        trigger: triggerConstants.TRIGGER_MOST_SAVED,
        viewMoreLink: '/collections/most-saved-items/?sort=newest',
        collectionTitle: trendingNowMostSavedItems,
    },
    [EXCELLENT_VALUES]: {
        value: EXCELLENT_VALUES,
        label: 'Excellent Values',
        trigger: triggerConstants.TRIGGER_EXCELLENT_VALUES,
        viewMoreLink: '/collections/excellent-values/?sort=newest',
        collectionTitle: trendingNowExcellentValues,
    },
    [BESTSELLING_DESIGNS]: {
        value: BESTSELLING_DESIGNS,
        label: 'Best-Selling Designs',
        trigger: triggerConstants.TRIGGER_BESTSELLERS,
        viewMoreLink: '/collections/best-sellers/?sort=newest',
        collectionTitle: trendingNowBestsellingDesigns,
    },
};
